/* eslint-disable */
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import Observer from 'react-intersection-observer';

import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';

import { isDesktop } from '../../utils/mobileHelpers';
import { isSafari } from '../../utils/browserChecker';

import styles from './index.styl';

@CSSModules(styles, { allowMultiple: true })
export default class ImageComponent extends PureComponent {
  static propTypes = {
    image: PropTypes.shape({
      url: PropTypes.string,
      thumbMin: PropTypes.string,
    }),
    dimensions: PropTypes.array,
    forceFetch: PropTypes.bool,
    className: PropTypes.string,
    onOpen: PropTypes.func,
    counter: PropTypes.number,
    relative: PropTypes.bool,
  };

  mounted = false;
  state = {
    image: null,
    loaded: false,
  };

  componentWillMount() {
    this.mounted = true;
    this.preloadImage();
  }

  componentWillUnmount(){
    this.mounted = false;
  }

  componentWillReceiveProps(nextProps) {
    const newImageValid =
      nextProps.image &&
      !isEqual(get(this.props.image, 'url'), get(nextProps.image, 'url'));

    if (newImageValid) {
      this.preloadImage(nextProps);
    }
  }

  preloadImage(props) {
    const { image, forceFetch } = props || this.props;
    const notUseObserver = isSafari() && !isDesktop();

    this.setState({
      image: null,
      loaded: false,
      notUseObserver,
    });

    const urlImage = get(image, 'url');
    const urlThumb = get(image, 'thumbMin');
    const cb = notUseObserver || forceFetch ? this.loadFullImage : () => {};

    this.preloadUrl(urlThumb, cb);
  }

  preloadUrl(url, callback) {
    const img = new Image();

    img.onload = () => {
      if (!this.mounted) {
        return ;
      }

      const isNeededImage = this.isAppropriateImage(url);

      isNeededImage &&
        this.setState(
          {
            image: url,
            loaded: !callback,
          },
          callback,
        );
    };
    img.src = url;
  }

  isAppropriateImage(url) {
    const { image } = this.props;

    const oUrl = get(image, 'url');
    const sUrl = get(image, 'thumbMin');

    return [oUrl, sUrl].includes(url);
  }

  loadFullImage() {
    this.preloadUrl(this.props.image.url);
  }

  getImage() {
    const { image, loaded } = this.state;
    const { counter, relative } = this.props;

    return (
      <Fragment>
        <img
          styleName={classNames('lazy-image', {
            'image--blurred': !loaded,
            'image--relative': relative,
          })}
          src={image}
        />
        {counter && <div styleName="image-counter">+{counter}</div>}
      </Fragment>
    );
  }

  render() {
    const { notUseObserver } = this.state;
    const { forceFetch, className, onOpen } = this.props;
    const image = this.getImage();

    if (notUseObserver || forceFetch)
      return (
        <div styleName={className} onClick={onOpen}>
          {image}
        </div>
      );

    return (
      <Observer
        styleName={className}
        onClick={onOpen}
        threshold={0.1}
        onChange={visible => (visible ? this.loadFullImage() : null)}
      >
        {image}
      </Observer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PostPreview/Image.jsx